export const Orange = '#EF4523'
export const Gray = '#676767'
export const LightGray = '#f6f5f5'
